import {Routes} from '@angular/router';
import {MainLayoutComponent} from "./core/layouts/main-layout/main-layout.component";
import {MsalGuard} from "@azure/msal-angular";
import {environment} from "../environments/environment";

export const routes: Routes = [
  {
    path: 'login-failed',
    title: 'LOGIN FAILED',
    loadComponent: () => import("./feature/not-found/page/not-found.component")
      .then(component => component.NotFoundComponent)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: environment.useMockAuth ? [] : [MsalGuard],
    children: [
      {
        path: '',
        title: 'Home | SSBA',
        loadComponent: () => import("./feature/home/page/home.component")
          .then(component => component.HomeComponent),
      },
      {
        path: 'facilities',
        title: 'Manage Facilities | SSBA',
        loadChildren: () => import("./feature/facilities/facilities.routes")
          .then(feature => feature.FACILITIES_ROUTES),
      },
      {
        path: 'entities',
        title: 'Manage Entities | SSBA',
        loadChildren: () => import("./feature/entities/entities.routes")
          .then(feature => feature.ENTITES_ROUTES),
      },
      {
        path: 'users',
        title: 'Manage Users | SSBA',
        loadChildren: () => import("./feature/users/users.routes")
          .then(feature => feature.USERS_ROUTES),
      },
      {
        path: 'auditlogs',
        title: 'View Audit Logs | SSBA',
        loadChildren: () => import("./feature/audit-logs/audit-logs.routes")
          .then(feature => feature.AUDITLOGS_ROUTES),
      },
      {
        path: 'submissions',
        title: 'Submissions | SSBA',
        loadComponent: () => import("./feature/submissions/page/submissions.component")
          .then(component => component.SubmissionsComponent),
      },
      {
        path: "**",
        title: 'SSBA',
        loadComponent: () => import("./feature/not-found/page/not-found.component")
          .then(component => component.NotFoundComponent)
      }
    ]
  }
]
